import { memo } from 'react'
import { NavLink } from 'react-router-dom'

import { Flex, Drawer, Divider, Button } from '@ui/index'

import { 
    IconApplications, IconArchive, IconClearClose, IconContracts, 
    IconDashBoard, 
    IconDelivery, IconEntity, IconExitApp, IconJobs, 
    IconKP, IconListeners, IconProfile, IconServer, 
    IconSignature,
    IconUsers, IconDiplom,
    IconPayment,
    IconAddress
} from '@img/icons'


/** Свойства главного мобильного меню */
export interface IDrawerMenu {
    isOpen: boolean
    
    handleButtonCancel?: () => void
    handleOpenModalExitProgram?: () => void
}


/** Главное мобильное меню */
export const DrawerMenu = memo(({isOpen, handleButtonCancel, handleOpenModalExitProgram}: IDrawerMenu) => {
    return <Drawer isOpen={isOpen} isEsc isWrapper onCancel={handleButtonCancel} maxWidth='340px' placement='right'>
        <Flex className='drawer_container'>
            <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                <h4>Основное меню</h4>

                <Button variant='icon' size='sm' onClick={handleButtonCancel}>
                    <IconClearClose width='20px' height='20px' />
                </Button>
            </Flex>

            <Flex gap='4px' className='drawer_container-body'>
                <Flex gap='6px' className='drawer_container-content'>
                    <NavLink to='/lk/dashboard' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconDashBoard />
                        <p>Мониторинг</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='/lk/applications' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconApplications />
                        <p>Заявки</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='/lk/signature' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconSignature />
                        <p>Договора на подпись</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='/lk/commercialOffers' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconKP />
                        <p>Ком. предложения</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='/lk/companies' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconEntity />
                        <p>Контрагенты</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px' />

                    <NavLink to='/lk/listeners' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconListeners />
                        <p>Слушатели</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='/lk/contracts' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconContracts />
                        <p>Договоры</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='/lk/finalExamination' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconJobs />
                        <p>Итоговые работы</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='/lk/archive' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconArchive />
                        <p>Архив работ</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='/lk/prints' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconDiplom />
                        <p>Печать</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='/lk/finality' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconDelivery />
                        <p>Доставка</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='/lk/paymentNotifications' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconPayment />
                        <p>Извещения о платежах</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='/lk/addressNotConfirmed' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconAddress />
                        <p>Адрес - не подтверждённые</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='/lk/profile' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconProfile />
                        <p>Мой профиль</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='/lk/users' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconUsers />
                        <p>Пользователи</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='/lk/systems' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handleButtonCancel}>
                        <IconServer />
                        <p>Система</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    {/* <Button variant='icon' size='md' onClick={handleButtonCancel}>
                        <IconMessage />
                        <p>Сообщения</p>
                    </Button>
                    
                    <Divider variant='dark' margin='8px'/> */}
                    
                    <button className='menu_button' onClick={() => {handleOpenModalExitProgram && handleOpenModalExitProgram(); handleButtonCancel && handleButtonCancel()}}>
                        <IconExitApp />
                        <p>Выход</p>
                    </button>
                </Flex>
            </Flex>
        </Flex>
    </Drawer>
})